import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { cx } from '../../lib/util/cx';

/** Port of the DS `SelectableChip`: pill; active = brown fill + white text, inactive = gray-100. */
export interface SelectableChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  icon?: ReactNode;
}

export function SelectableChip({
  active = false,
  icon,
  className,
  children,
  type = 'button',
  ...rest
}: SelectableChipProps) {
  return (
    <button
      type={type}
      aria-pressed={active}
      className={cx(
        'inline-flex items-center gap-1.5 rounded-pill border px-3.5 py-1.5 font-body text-sm font-medium',
        'transition-[background-color,color,border-color] duration-fast disabled:cursor-not-allowed disabled:opacity-50',
        active ? 'border-brown bg-brown text-white' : 'border-transparent bg-[var(--hp-gray-100)] text-ink',
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}
